export default __webpack_public_path__ + "static/media/GranolaDehesa.02a9168e.JPG";